module.exports = __webpack_public_path__ + "static/media/reminder.b00aaf29.svg";